import { useSalesforceAhoyProperties } from '../hooks/useSalesforceAhoyProperties';
import { SalesforceFieldMappingManager } from './SalesforceFieldMappingManager';

interface SalesforceMappingsManagerViewProps {
  orgId: number | string;
  connected: boolean;
  onBack?: () => void;
}

export function SalesforceMappingsManagerView({
  orgId,
  connected,
  onBack,
}: SalesforceMappingsManagerViewProps) {
  const availablePropertiesByObject = useSalesforceAhoyProperties(orgId);

  return (
    <SalesforceFieldMappingManager
      orgId={orgId}
      availablePropertiesByObject={availablePropertiesByObject}
      connected={connected}
      onBack={onBack}
    />
  );
}
